import React, { useState } from 'react';
import styled from 'styled-components';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { app } from '../../firebase';
import { useNavigate } from 'react-router-dom';
import Loader from '../../component/loader';

const StyledWrapper = styled.div`
  height: 100vh;
  width: 100vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  background: url('/rm222batch5-mind-03.jpg') no-repeat center center fixed;
  background-size: cover;

  .header {
    text-align: center;
    color: white;
    margin-bottom: 30px;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.7);

    h1 {
      font-size: 5rem;
      margin-bottom: 10px;
      color:rgb(78, 10, 237);
    }

     h2 {
      font-size: 1.5rem;
      margin-bottom: 10px;
      color:rgb(0, 0, 0);
    }

    p {
      font-size: 1.125rem;
      font-weight: 300;
        color:rgb(41, 48, 236);
    }
  }

  .form_container {
    background: rgba(255, 255, 255, 0.95);
    padding: 40px;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
    max-width: 400px;
    width: 100%;
  }

  .title_container {
    margin-bottom: 20px;
  }

  .title {
    font-size: 1.5rem;
    font-weight: bold;
    color: #007bff;
  }

  .subtitle {
    font-size: 0.875rem;
    color: #555;
  }

  .input_container {
    margin-top: 20px;
    position: relative;
  }

  .input_label {
    display: block;
    margin-bottom: 8px;
    font-size: 0.875rem;
    color: #333;
  }

  .input_field {
    width: 100%;
    padding: 12px 40px 12px 12px;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 8px;
    box-sizing: border-box;
  }

  .icon {
    position: absolute;
    right: 10px;
    top: 35px;
    cursor: pointer;
    user-select: none;
  }

  .error-message {
    color: red;
    margin-top: 10px;
    font-size: 0.875rem;
  }

  .login_btn {
    margin-top: 30px;
    width: 100%;
    padding: 12px;
    font-size: 1rem;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .login_btn:hover {
    transform: scale(1.03);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  }
`;

const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const auth = getAuth(app);
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      const tokenResult = await user.getIdTokenResult();
      if (tokenResult.claims.admin) {
        navigate('/dashboard');
      } else {
        setError('You do not have admin access.');
        await auth.signOut();
      }
    } catch (err) {
      handleAuthError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleAuthError = (err) => {
    switch (err.code) {
      case 'auth/invalid-credential':
        setError('The email or password you entered is incorrect. Please try again.');
        break;
      case 'auth/invalid-email':
        setError('Please enter a valid email address (e.g., user@example.com).');
        break;
      case 'auth/user-not-found':
        setError('No account found with this email. Please sign up first.');
        break;
      case 'auth/too-many-requests':
        setError('Too many failed attempts. Please try again later.');
        break;
      default:
        setError('Login failed. Please try again.');
    }
    console.error('Login error:', err);
  };

  return (
    <StyledWrapper>
      {loading && <Loader />}
      <div className="header">
      <h1>Internskool</h1>
        <h2>Welcome Back!</h2>
        <p>Please sign in to access the admin dashboard</p>
      </div>
      <form className="form_container" onSubmit={handleLogin}>
        <div className="title_container">
          <p className="title">Login to your Account</p>
          <span className="subtitle">Admin access only. Use your credentials to log in.</span>
        </div>
        <div className="input_container">
          <label className="input_label" htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            className="input_field"
            placeholder="name@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="input_container">
          <label className="input_label" htmlFor="password">Password</label>
          <input
            type={passwordVisible ? 'text' : 'password'}
            id="password"
            className="input_field"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <span className="icon" onClick={() => setPasswordVisible(!passwordVisible)}>
            {passwordVisible ? '🙈' : '👁️'}
          </span>
        </div>
        {error && <div className="error-message">{error}</div>}
        <button type="submit" className="login_btn">Login</button>
      </form>
    </StyledWrapper>
  );
};

export default LoginForm;

